import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-smart-feedback-button',
  standalone: false,
  templateUrl: './smart-feedback-button.component.html',
  styleUrl: './smart-feedback-button.component.scss',
})
export class SmartFeedbackButtonComponent {
  @Input() loading = false;

  @Input() ready = false;

  @Input() isDisabled = false;

  @Input() tooltipMessage: string;

  @Output() readonly buttonClicked = new EventEmitter<boolean>();

  handleButtonClick() {
    this.buttonClicked.emit(true);
  }
}
